import React from "react";
import TCPA from "@components/shared/form/TCPA";
import { FormReducerAction, Operation } from "../types";
import { DomainInfo } from "src/api/domainInfo";
import { DomainForm } from "src/api/domainForm";
import { Step } from "@lib/shared/types";

export interface BuildTcpaArgs {
    isSecondServiceForm: boolean | undefined;
    isSecondServiceSelected: boolean;
    showTCPAMessage: boolean;
    formErrors: unknown;
    operation: Operation | null | undefined;
    domain: DomainInfo;
    finalForm: DomainForm;
    steps: Step[];
    currentStep: number;
    classes?: { tcpaClassName?: string };
    submitButtonText: string | undefined;
    dispatch: React.Dispatch<FormReducerAction>;
}

/**
 * Build the TCPA element used inside the new form.
 * Returns `undefined` when TCPA should not be rendered.
 */
export function buildTcpaElement({
    isSecondServiceForm,
    isSecondServiceSelected,
    showTCPAMessage,
    formErrors,
    operation,
    domain,
    finalForm,
    steps,
    currentStep,
    classes,
    submitButtonText,
    dispatch,
}: BuildTcpaArgs): React.ReactElement | undefined {
    const showTCPA =
        ((isSecondServiceForm && isSecondServiceSelected) ||
            (!isSecondServiceForm && showTCPAMessage && !formErrors)) &&
        (!operation?.loadingBuyers || operation?.firstRoundBuyers?.length);

    const domainTcpa = domain?.textBlocks?.find(
        (textEl) => textEl.position === "custom-domain-tcpa",
    )?.text;

    if (!showTCPA) {
        return undefined;
    }

    return (
        <TCPA
            content={
                (domainTcpa
                    ? domainTcpa
                    : finalForm.tCPAMessages
                    ? finalForm.tCPAMessages
                    : steps[currentStep].TCPAMessage) ?? ""
            }
            className={classes?.tcpaClassName ?? ""}
            buttonText={submitButtonText}
            operation={(operation as Partial<Operation> | null) ?? {}}
            dispatch={dispatch}
            position={
                domain.config?.tcpaPosition ??
                (domain.categories[0]?.config?.tcpaPosition ===
                "aboveSubmitButton"
                    ? "aboveSubmitButton"
                    : "bottom")
            }
        />
    );
}
